import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { SelectItem } from 'primeng/api';
import { StoreService } from '../_services/store.service';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.css'],
})
export class StoresComponent implements OnInit {
  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  stores: any[] = [];
  selectedStore: any;

  groups: any[] = [{ label: 'None', value: null }];
  apps: any[] = [{ label: 'None', value: null }];
  owners: any[] = [{ label: 'None', value: null }];

  currencies: any = this.globals.currencies;

  filters: any;

  sidebarVisible = false;
  createStoreModal = false;
  createStoreForm: FormGroup;
  errMsgs: any[] = [];

  pageSizes: any = environment.pageSizes;
  pagination: any;

  selectedSort: any;

  sortFields: any[] = [
    {
      sortName: 'Name (asc)',
      sortString: 'name,asc',
    },
    {
      sortName: 'Name (desc)',
      sortString: 'name,desc',
    },
  ];

  filterFields: any[] = [
    {
      type: 'input',
      label: 'Store name',
      name: 'name',
      placeholder: 'Enter store name',
    },
    {
      label: 'Submit',
      name: 'submit',
      type: 'button',
    },
  ];

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public _storeService: StoreService
  ) {
    this.createStoreForm = fb.group({
      name: new FormControl('', [Validators.required]),
      address1: new FormControl('', [Validators.required]),
      address2: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      postcode: new FormControl(''),
      currency: new FormControl('', [Validators.required]),
      // group: new FormControl(''),
      // owner: new FormControl(''),
      // app: new FormControl(''),
    });

    this.selectedSort = this.sortFields[0];
    this.resetPagination();
  }

  ngOnInit() {
    this.getAllStores();
  }

  public getAllStores() {
    this._storeService
      .getAllStores(this.pagination, this.selectedSort.sortString)
      .subscribe((data: any) => {
        console.log(data);
        this.stores = data.body;
        this.pagination.totalRecords = data.headers.get('x-total-count');
      });
  }

  // Get all groups
  public getAllGroups() {}

  // Get all store owner users
  public getAllOwners() {}

  // Get all mobile applications
  public getAllApps() {}

  /* PAGINATION */
  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
  }

  paginate(event) {
    console.log(event);
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
  }
  /* PAGINATION END */

  // Handle onRowSelect (ie Select Single Patient and navigate to inner view)
  onRowSelect(event) {
    this.router.navigate(['/' + this.globals.user.routeRole + '/products/' + event.data.id]);
  }

  public toggleCreateStoreModal() {
    this.createStoreModal = !this.createStoreModal;
  }

  public onCreateStoreFormSubmit() {
    const values = this.createStoreForm.value;
    values.currency = values.currency.value;
    this._storeService.createStore(values).subscribe((data: any) => {
      this.createStoreForm.reset();
      this.toggleCreateStoreModal();
      if (this.globals.user.routeRole === 'group') {
        this._storeService
          .setStoreGroup(data.id, this.globals.user.id)
          // tslint:disable-next-line:no-shadowed-variable
          .subscribe((data: any) => {
            this.getAllStores();
            this.notificationService.notify(
              'success',
              'Store Created',
              'New Store has successfully been created',
              'top',
              'right'
            );
          });
      } else {
        this.getAllStores();
        this.notificationService.notify(
          'success',
          'Store Created',
          'New Store has successfully been created',
          'top',
          'right'
        );
      }
    });
  }

  sortChange(event) {
    this.selectedSort = event;
    this.resetPagination();
  }

  filterFormSubmitted(value) {
    this.sidebarVisible = false;
    this.filters = value;
    this.resetPagination();
  }

  clearFilters() {
    this.sidebarVisible = false;
    this.filters = '';
    this.filterForm.clearForm();
    this.resetPagination();
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/stores.component.ts